var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 20C21.6667 21.6569 20.3235 23 18.6667 23L9.66666 23C8.00981 23 6.66667 21.6569 6.66667 20L6.66667 7C6.66667 5.34315 8.00981 4 9.66667 4L18.6667 4.00001C20.3235 4.00001 21.6667 5.34315 21.6667 7L21.6667 20Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 14.5L26.6667 22.6667C26.6667 25.6122 24.2789 28 21.3333 28L13.1667 28",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.97029,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.e83b9214b4a9da8bd90638892d3463f5.svg";
export { ForwardRef as ReactComponent };